import SyncSwapLethEthClassicPoolModule from './SyncSwapLethEthClassicPool';
export default class SyncSwapVnoEthClassicPoolModule extends SyncSwapLethEthClassicPoolModule {
    constructor() {
        super(...arguments);
        this.contractAddress = this.sdk.addresses.vvsPair;
    }
}
